<div class="mockup-code">
	<pre class="px-4"><code><slot /></code></pre>
</div>
